import { FC, useEffect } from 'react';
import { COLOR_ELEMENT_IDENTIFIER } from '../../screens/ConsumerChannelsConfigScreen/constants';
import { IValidation } from 'src/types/main';
import Input from 'src/view/components/Controls/InputComponent/Input';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

interface IProps {
  title: string;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  onFocus: () => void;
  isActive?: boolean;
  validation?: IValidation;
  noTranslate?: boolean;
  instantFocus?: boolean;
}

const ColorsRow: FC<IProps> = (props: IProps): JSX.Element => {
  useEffect(() => {
    if (props.instantFocus) props.onFocus();
  }, []);

  return (
    <div className="colors-row">
      <Text type={TEXT.ORDER_FIELD} text={props.title} noTranslate={props.noTranslate} className="colors-row__title pr-4" />
      <div className="d-flex flex-row gap-10">
        <Input
          id={COLOR_ELEMENT_IDENTIFIER.INPUT}
          value={props.value}
          validation={props.validation}
          onChangeValue={props.onChange}
          onFocus={props.onFocus}
          contentClassName="colors-row__color-input"
          inputClassName="text-center"
        />
        <div className="colors-row__color-box-wrapper" style={{ borderColor: props.isActive ? props.value : undefined }}>
          <button
            id={COLOR_ELEMENT_IDENTIFIER.BOX}
            className="colors-row__color-box"
            onFocus={props.onFocus}
            style={{ backgroundColor: props.value }}
          />
        </div>
      </div>
    </div>
  );
};

export default ColorsRow;
